import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Col from 'antd/es/grid/col'
import Switch from 'antd/es/switch/index'
import { useAppSelector } from '@/redux/hooks.ts'
import { toggleShowLiquidatedIdeas } from '@/redux/slices/idea-list-input.slice.ts'
import { useFixedBreakpoint } from '@/common/hooks/use-is-mobile.ts'
import IdeyaTypography from '@/common/antd/ideya-typography.tsx'
import Row from 'antd/es/grid/row'
import { convertPxToNumber } from '@/utils/helpers'
import { selectThemeStyle } from '@/features/setting/setting.slice'
import { RowProps } from 'antd/lib'
import { RootState } from '@/redux/store.ts'

interface ShowLiquidatedSwitchProps {
  rowProps?: RowProps
  /** Controlled value — when provided, the switch uses this instead of ideaListInput */
  value?: boolean
  /** Controlled onChange — when provided, called instead of dispatching to ideaListInput */
  onChange?: (checked: boolean) => void
}

export const ShowLiquidatedSwitch = ({
  rowProps = {},
  value: controlledValue,
  onChange: controlledOnChange,
}: ShowLiquidatedSwitchProps) => {
  const themeStyle = useAppSelector(selectThemeStyle)
  // Only subscribe to the specific field to avoid re-renders from unrelated ideaListInput changes
  const ideaListShowLiquidated = useAppSelector(
    (state: RootState) => state.ideaListInput.showLiquidatedIdeas
  )
  const dispatch = useDispatch()
  const screens = useFixedBreakpoint()
  const isMobile = !screens.md
  const { t } = useTranslation()

  // Use controlled props when provided, otherwise fall back to ideaListInput
  const switchValue = controlledValue ?? ideaListShowLiquidated
  const handleChange =
    controlledOnChange ??
    ((v: boolean) => dispatch(toggleShowLiquidatedIdeas(v)))

  return (
    <Row
      gutter={[
        convertPxToNumber(themeStyle.marginXS),
        convertPxToNumber(themeStyle.marginXS),
      ]}
      {...rowProps}
    >
      <Col>
        <Switch value={switchValue} onChange={handleChange} />
      </Col>
      <Col>
        <IdeyaTypography.Text>
          {isMobile
            ? t('idea_list.user_controls.show_liquidated')
            : t('idea_list.user_controls.show_liquidated_ideas')}
        </IdeyaTypography.Text>
      </Col>
    </Row>
  )
}
